import React, { useLayoutEffect, useRef } from 'react';
import { mountSunLoader } from './sun-loader-canvas.js';

/**
 * Знак ожидания — ядро знака Lumos, вокруг которого летают три планеты.
 *
 * Планеты идут по вытянутым кеплеровым орбитам с ядром в фокусе
 * (`three-body.ts`), в трёх наклонённых плоскостях, как электроны в знаке
 * атома, со сдвигом в треть цикла: у ядра разгоняются, вдали — зависают;
 * уходят за ядро и выходят перед ним, но сквозь не проходят. За каждой
 * разворачивается линия пройденного пути — яркая у планеты, тающая к хвосту,
 * длиннее на быстром участке. Ближнее крупнее и ярче, дальнее — втрое меньше
 * и тусклее, за ядром — закрыто им. Ядро дышит, блик вспыхивает. Цикл — 5,4 с,
 * без шва на стыке.
 *
 * Мельче 32 px — только ядро и три точки. «Меньше движения»
 * (`prefers-reduced-motion`) — планеты стоят, линий нет, дышит только ядро.
 *
 * Рисует `<canvas>` (`sun-loader-canvas.ts`): спрайты градиентов строятся один
 * раз под размер и плотность экрана, на кадр — несколько `drawImage` и штрихов.
 * Фаза — от загрузки страницы: все индикаторы на экране идут в такт, а
 * заставка из index.html (то же ядро без планет) сменяется индикатором без
 * скачка — планеты проявляются, линии разворачиваются. Числа те же, что у
 * `LumosLoader` в приставке.
 */
export function SunLoader({ className }: { className?: string }): React.JSX.Element {
  const host = useRef<HTMLSpanElement>(null);
  const canvas = useRef<HTMLCanvasElement>(null);
  useLayoutEffect(() => {
    if (!host.current || !canvas.current) return undefined;
    return mountSunLoader(host.current, canvas.current);
  }, []);
  return (
    <span ref={host} className={className === undefined ? 'sun-loader' : `sun-loader ${className}`} aria-hidden="true">
      <canvas ref={canvas} />
    </span>
  );
}
